import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client'
import { AuthToken, AuthUser } from '../typings/auth.def'
import CONFIG from '../config'
import { setContext } from '@apollo/client/link/context'

let inmemory_jwt_token = ''

export const setApolloAuth = (user: AuthUser) => {
  inmemory_jwt_token = user.jwt_token
  localStorage.setItem(AuthToken.Refetch, user.resume_token)
}

export function unsetApolloAuth(): void {
  inmemory_jwt_token = ''
  localStorage.clear()
}

const httpLink = createHttpLink({
  uri: CONFIG.REACT_APP_HASURA_HTTP
})

const httpLinkApollo = createHttpLink({
  uri: CONFIG.REACT_APP_STUDENTS_APOLLO
})

const authLink = setContext((_, { headers }) => {
  const token = inmemory_jwt_token
  if (process.env.NODE_ENV !== 'production') {
    console.log(`Bearer ${token}`)
  }
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

export const studentsApolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  connectToDevTools: process.env.NODE_ENV === 'development',
  link: authLink.concat(httpLinkApollo)
})

const hasuraClient = new ApolloClient({
  cache: new InMemoryCache(),
  connectToDevTools: process.env.NODE_ENV === 'development',
  link: authLink.concat(httpLink)
})

export default hasuraClient
